import React, { useContext } from "react";

import { SoundContext } from "../App";
import volumeOn from "./voulume_on.svg";
import volumeOff from "./volume_off.svg";
import PomodoroAppIcon from "../PomodoroAppIcon.svg";
import "./Header.scss";

const Header = () => {
  const soundContext = useContext(SoundContext);
  const isSoundEnabled = soundContext.get;

  const toggleSound = () => {
    if (isSoundEnabled) {
      soundContext.set(false);
    } else {
      soundContext.set(true);
    }
  };

  return (
    <div className="header">
      <div>
        <img className="header-app-icon" src={PomodoroAppIcon} alt="" />
      </div>
      <div>
        <img
          src={isSoundEnabled ? volumeOff : volumeOn}
          title={isSoundEnabled ? "Diable Sounds" : "Enable Sounds"}
          alt={"volume off"}
          onClick={toggleSound}
        />
        <a
          className="h-question"
          href={"https://en.wikipedia.org/wiki/Pomodoro_Technique"}
          target={"_blank"}
          rel={"noopener noreferrer"}
        >
          What is Pomodoro?
        </a>
      </div>
    </div>
  );
};

export default Header;
